import { render } from "./AddBlockModal.vue?vue&type=template&id=2321b288"
import script from "./AddBlockModal.vue?vue&type=script&lang=js"
export * from "./AddBlockModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__